import { OrderOrShipmentTemplate } from '@/model';

import { BaseHttpController } from './BaseHttpController';

export class OrderOrShipmentTemplateController extends BaseHttpController {
  static readonly ENDPOINT = 'order-or-shipment-template';

  constructor() {
    super(OrderOrShipmentTemplateController.ENDPOINT);
  }

  async findAll(
    includeShipmentTemplates = false,
  ): Promise<OrderOrShipmentTemplate[]> {
    const response = await this.http.get<OrderOrShipmentTemplate[]>('', {
      params: { includeShipmentTemplates },
    });
    return response.data.map((val) => new OrderOrShipmentTemplate(val));
  }

  async create(
    template: OrderOrShipmentTemplate,
  ): Promise<OrderOrShipmentTemplate> {
    if (template.id != null) {
      throw new Error('Id expected to be null when calling create');
    }

    const response = await this.http.post<OrderOrShipmentTemplate>('', {
      template,
    });
    return new OrderOrShipmentTemplate(response.data);
  }

  async update(
    template: OrderOrShipmentTemplate,
  ): Promise<OrderOrShipmentTemplate> {
    if (template.id === undefined) {
      throw new Error('Id expected to be defined when calling update');
    }

    const response = await this.http.put<OrderOrShipmentTemplate>('', {
      template,
    });
    return new OrderOrShipmentTemplate(response.data);
  }

  async setDefaultOrderTemplate(templateId?: number): Promise<void> {
    if (templateId === undefined) {
      throw new Error(
        'Id expected to be defined when calling setDefaultOrderTemplate',
      );
    }
    await this.http.put<void>('set-default/order', { templateId });
  }

  async setDefaultShipmentTemplate(templateId?: number): Promise<void> {
    if (templateId === undefined) {
      throw new Error(
        'Id expected to be defined when calling setDefaultShipmentTemplate',
      );
    }
    await this.http.put<void>('set-default/shipment', { templateId });
  }

  async delete(templateId: number): Promise<void> {
    await this.http.delete<void>(`${templateId}`);
  }
}
